
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { OrdineMTMTestata, RequestAllegatoDownload } from '@/models';
import { StoreActions, store } from '@/store';
import saveAs from "file-saver";

@Component
export default class ItemListOrdine extends Vue {
    @Prop() private ordine!: OrdineMTMTestata;

    private iconClassByStatus(ord: OrdineMTMTestata): string {
        if (ord.stato == "ORDINE INSERITO") {
            return 'green';
        } else if (ord.stato == "IN LAVORAZIONE") {
            return 'amber';
        } else {
            return 'blue';
        }
    }
    // formatDate (date: string): string {
    //     if (!date) return '';

    //     const [year, month, day] = date.split('-');
    //     return `${day}/${month}/${year}`;
    // }
    private showDetail() {
        this.$router.push({ name: 'ordine-mtm', params: { id: this.ordine.id } });
    }

    private async downloadAllegato(id: number, nomeFile: string, fornitore: string) {

        let request: RequestAllegatoDownload = {
            idAllegato: id,
            fornitore: fornitore
        }

        let data = await store.dispatch(StoreActions.DownloadAllegato, request);
        if (data) {
            saveAs(data, nomeFile);
        }
    }

    private buttonDownloadIsLoading(id: number) {
        return store.state.uiOrdiniMTM.downloadButtonLoading == id;
    }

    private getStringBeforeUnderscore(inputString: string): string {
        // Controlla se il simbolo underscore (_) è presente nella stringa
        const underscoreIndex = inputString.indexOf('_');

        // Se è presente, restituisci la parte della stringa prima di esso
        if (underscoreIndex !== -1) {
            return inputString.substring(0, underscoreIndex);
        }

        // Altrimenti restituisci l'intera stringa
        return inputString;
    }
}
